<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('EVENTS.EDIT.TITLE')"
      :header-content="$t('EVENTS.EDIT.DESC')"
    />
    <event-form
      :value="value"
      :is-submitting="uiFlags.isUpdating"
      @submit="onSubmit"
      @cancel="onClose"
    />
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import EventForm from './EventForm';

export default {
  components: {
    EventForm,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'events/getUIFlags',
    }),
  },
  methods: {
    async onSubmit(eventData) {
      try {
        await this.$store.dispatch('events/update', {
          id: this.id,
          ...eventData,
        });
        this.showAlert(this.$t('EVENTS.EDIT.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('EVENTS.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>
